/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon16Regular = forwardRef('ArrowRoundTimeForwardIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.157 2.937a5.503 5.503 0 1 0 2.784 7.484.75.75 0 1 1 1.347.66 7.002 7.002 0 1 1-.789-7.416V2.128a.75.75 0 0 1 1.5 0v4.127a.75.75 0 0 1-.75.75h-3.515a.75.75 0 0 1 0-1.5h2.2a.749.749 0 0 1-.111-.155 5.503 5.503 0 0 0-2.666-2.413Z" })));
});
